export const EXAM_COURSE_ROUTES = {
  plans: '/exam-courses',
  masterExams: '/exam-courses/master-exams',
  detail: '/exam-courses/detail',
  tabs: '/exam-courses/tabs',
  subjects: '/exam-courses/subjects',
  lectureSubjects: '/exam-courses/subjects/lectures',
  questionBankSubjects: '/exam-courses/subjects/question-bank',
  shortNotesSubjects: '/exam-courses/subjects/short-notes',
  resources: '/exam-courses/resources',
};
